var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedtestLightLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 276,
    viewBox: "0 0 306 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M305.4 150.6V275.6H0.600098V150.6H41.7001V234.6H264.3V150.6H305.4Z",
    fill: "#068D93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M305.4 125.3V0.399994H0.600098V125.3H41.7001V41.4H264.3V125.3H305.4Z",
    fill: "#068D93"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M205.8 117.5H173.5V85.1H132.5V117.5H100.2V158.5H132.5V190.8H173.5V158.5H205.8V117.5Z",
    fill: "#5DC9B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedtestLightLogo);
export default __webpack_public_path__ + "static/media/medtest-light-logo.1b46db7a73e006f38f29f41009293fb5.svg";
export { ForwardRef as ReactComponent };